import React, { useState, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import AuthContext from '@/product/context/auth/authContext'

import Lottie from 'react-lottie'
import animationData from './lottie/paymentAnimation.json'
import successAnimation from './lottie/successAnimation.json'
import failureAnimation from './lottie/failureAnimation.json'
import verificationAnimation from './lottie/verificationAnimation.json'
import pendingAnimation from './lottie/pendingAnimation.json'

import { handleRedirectInternal, mapData } from '@/product/common/components'
import CustomDialog from '@/product/components/organisms/Dialog'
import { Button } from '@mui/material'
import StripeSellerContext from '@/product/context/stripe/seller/sellerContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'

const StripeSeller = (props) => {
    const authContext = useContext(AuthContext)
    const [paymentResponse, setPaymentResponse] = useState(null)
    const [rosoomResponse, setRosoomResponse] = useState(null)
    const [toggleDialogDeposit, setToggleDialogDeposit] = useState(false)

    const { onboardStatus, responseStatus: responseStatusStripeSeller } =
        useContext(StripeSellerContext)

    const changeDialogStatusDeposit = () => {
        setToggleDialogDeposit(!toggleDialogDeposit)
    }

    const { isAuthenticated, loadUser } = authContext
    const history = useHistory()

    useEffect(() => {
        if (isAuthenticated) {
            onboardStatus()
            setPaymentResponse(null)
        }
    }, [isAuthenticated])

    const defaultOptions = {
        loop: true,
        autoplay: true,
        speed: '0.25',
        animationData: verificationAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    }

    const paymentSuccessOptions = {
        loop: true,
        autoplay: true,
        speed: '0.25',
        animationData: successAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    }

    const onboardingPendingOptions = {
        loop: false,
        autoplay: true,
        speed: '0.25',
        animationData: pendingAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    }

    const paymentFailureOptions = {
        loop: true,
        autoplay: true,
        speed: '0.25',
        animationData: failureAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    }

    useEffect(() => {
        if (responseStatusStripeSeller) {
            if (responseStatusStripeSeller.from === 'onboardStatus') {
                if (responseStatusStripeSeller.status === 'success') {
                    setPaymentResponse(responseStatusStripeSeller)
                    setToggleDialogDeposit(true)
                }
            }
        }
    }, [responseStatusStripeSeller])

    const redirectFunction = () => {
        if (paymentResponse.status === 'success') {
            loadUser()
            if (paymentResponse.type) {
                if (paymentResponse.type === 6) {
                    window.open(`${paymentResponse.data.url}`, '_self')
                } else if (paymentResponse.type === 7) {
                    handleRedirectInternal(history, 'onboarding')
                } else {
                    handleRedirectInternal(history, 'onboarding')
                }
            } else {
                handleRedirectInternal(history, '')
            }
        } else {
            handleRedirectInternal(history, '')
        }
    }
    const laterFunction = () => {
        handleRedirectInternal(history, 'onboarding')
    }
    return (
        <div className="container">
            <div className="onBoardingResponse">
                <Lottie
                    options={defaultOptions}
                    speed="0.25"
                    height={300}
                    width={400}
                />
                <h2>We are verifying your details.</h2>
                <h4>
                    Please do not press the back button or refresh the page.
                </h4>
            </div>
            {paymentResponse && paymentResponse.status ? (
                <CustomDialog
                    title=""
                    open={toggleDialogDeposit}
                    className="onBoardingNotifCnt"
                    ///function={changeDialogStatusDeposit}
                >
                    <div>
                        {paymentResponse.status === 'success' ? (
                            <>
                                {paymentResponse.type === 6 ? (
                                    <div className="onBoardingNotif">
                                        <Lottie
                                            options={onboardingPendingOptions}
                                            speed="0.25"
                                            height="auto"
                                            width={150}
                                        />
                                        <div>
                                            <h3>Onboarding is Pending!</h3>
                                            <h5>
                                                Note: If you have completed.
                                                Please wait for a while and try
                                                again!
                                            </h5>
                                            <div className="onBoardingAct">
                                                <PrimaryButton
                                                    onClick={() =>
                                                        redirectFunction()
                                                    }
                                                >
                                                    Complete Onboarding
                                                </PrimaryButton>
                                                <Button
                                                    onClick={() =>
                                                        laterFunction()
                                                    }
                                                >
                                                    Complete Later
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                ) : paymentResponse.type === 7 ||
                                  paymentResponse.type === 5 ? (
                                    <div className="onBoardingNotif">
                                        <Lottie
                                            options={paymentSuccessOptions}
                                            speed="0.25"
                                            height="auto"
                                            width={150}
                                        />
                                        <div>
                                            <h3>
                                                Your Stripe account is
                                                successfully set up.
                                            </h3>
                                            <h5>
                                                Please add your Bank
                                                details/Card to receive payout.
                                            </h5>
                                            <div className="onBoardingAct">
                                                <PrimaryButton
                                                    onClick={() =>
                                                        redirectFunction()
                                                    }
                                                >
                                                    Complete Payout
                                                </PrimaryButton>
                                                <Button
                                                    onClick={() =>
                                                        laterFunction()
                                                    }
                                                >
                                                    Complete Later
                                                </Button>
                                            </div>
                                        </div>{' '}
                                    </div>
                                ) : null}
                            </>
                        ) : (
                            <div className="onBoardingNotif failure">
                                <Lottie
                                    options={paymentFailureOptions}
                                    speed="0.25"
                                    height="auto"
                                    width={150}
                                />
                                <div>
                                    <h3>Payment Failed.</h3>
                                    {/* <h5>
                                    Your payment of {currencyFormat(rosoomResponse.serviceCost)} has
                                    unfortunately failed.
                                </h5> */}
                                    {/* <Button onClick={() => redirectFunction()}>OK</Button> */}
                                </div>
                            </div>
                        )}
                    </div>
                </CustomDialog>
            ) : null}
        </div>
    )
}

export default StripeSeller
